import {LocalStorageService} from "./local-storage-service";

const getConfig = () => {
    return window.AppSettings
}

const getRisTitle = () => {
    return window?.AppSettings?.ris?.title[LocalStorageService.getLanguage('tr')]
}

// Uygulama içi sekme davranışı: 'in-app' | 'browser'
const getTabMode = () => window?.AppSettings?.tabs?.mode || 'in-app'
const isInAppTabs = () => getTabMode() === 'in-app'

const AppConfig = {
    getConfig,
    getRisTitle,
    getTabMode,
    isInAppTabs
}

export default AppConfig;